import { Box, makeStyles, Typography } from '@material-ui/core'
import { DropZone } from '@shopify/polaris';
import React from 'react'
import { useTranslation } from 'react-i18next';
import Lightbox from "react-awesome-lightbox";

const useStyles = makeStyles(()=>{return{
    relative:{
        position:'relative',
    },
    imgMargBorder:{
        marginTop: '1rem', 
        borderRadius: '2.8px',
        height: '69.7px',
        width: '70.19px',
        cursor:'pointer'
    },
    backgroundColorImg:{ 
        backgroundColor: '#DFE3E8'
    },
    imagePlaceholder:{
        position:'absolute',
        width: '62px',
        height: '15px',
        left:'50%',
        transform: 'translateX(-50%)',
        color: '#FFFFFF',
        backgroundColor:'rgba(0,0,0,0.6)',
        fontSize: '9px !important',
        letterSpacing: 0,
        lineHeight: '13px',
        textAlign: 'center',
        bottom: 10,
        ['@media only screen and (max-width: 500px) '] : {
            transform: 'translateX(7%)',
            left:0
        }
    },
    loadingBox:{
        margin: "0 auto",
        textAlign: "center",
        padding : 30
   },
  dropZoneDesign: {
    position: "absolute",
    width: "62px",
    height: "15px",
    left: "50%",
    bottom: 10,
    transform: "translateX(-50%)",
    border: "0.1rem solid #000",
    opacity: 0,
    "& div": {
      minHeight: "15px",
      "& div": {
        minHeight: "15px",
      },
    },
    ["@media only screen and (max-width: 500px) "]: {
      transform: "translateX(7%)",
      left: 0,
    },
  },
}})
export default function SinglePhoto({
  handleImages,
  id,
  value,
  disable,
  imagesArray = [],
  setIsOpen,
  handleIndexChange,
  index,
  isOpen = false,
  fileName = null,
  fileType = null,
  title = null,
}) {    
  const classes = useStyles();
    const { t } = useTranslation();
  let isStaticImage = false;
  if (value && value.startsWith("/static/media")) {
    isStaticImage = true;
  }
  return (
    <Box className={classes.relative}>
        {value && !isStaticImage ?
            <label htmlFor={id}> 
                {(fileType && fileType.includes('video')) ?
                    <video className={classes.imgMargBorder} src={value} controls /> :
                    <Box
                      component="img"
                      className={classes.imgMargBorder}
                      src={value}
                      onClick={() => handleIndexChange(id)}
                    />
                }
            </label>
        :
            <label htmlFor={id}> 
                <Box className={`${classes.imgMargBorder} ${classes.backgroundColorImg}`} />
            </label>
        }
        <Typography
          style={{ cursor: disable ? "not-allowed" : "pointer" }}
          className={classes.imagePlaceholder}
        >
          {title ? title : value ? t("Replace") : t("Upload-image")}
        </Typography>
        <div
            className={classes.dropZoneDesign}
        >
            <DropZone
                disabled={disable || isOpen}
                onDropAccepted={(file) => fileName ? handleImages(file, id, fileName) : handleImages(file, id)}
                id={id}
            >
            </DropZone>
        </div>
        {isOpen && imagesArray?.length ? (
          <Lightbox
            startIndex={index}
            onClose={() => setIsOpen(false)}
            images={imagesArray}
          />
        ) : (
          ""
        )}
    </Box>
  )
}
